// extracted by mini-css-extract-plugin
export default {"mainCard":"VideoCarousal_mainCard__Drgdv","depression":"VideoCarousal_depression__NR+VA"};